var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "computer-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 30.115,
    height: 43.418,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_308",
    "data-name": "Groupe 308",
    transform: "translate(-1331 -39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1331 42)",
    fill: "#39003c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_274",
    "data-name": "Groupe 274",
    transform: "translate(1339.942 39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1163",
    "data-name": "Trac\\xE9 1163",
    d: "M19.49,0l2.543,1.1,3.815.876,3.281,3.371V3.98L30.535,6.1l.536,2.754,1.985,1.83-.7,2.866v1.352l-.962.768v3.544l-1.184,3.242H25.543l-4.436-8.853L7.693,18.616,6.2,16.38l-.614-1.4.452-3.194L5.3,8.982,7.365,6.289l1.669-.934L8.183,3.486l3.27-1.518,3.325-.179V.612Z",
    transform: "translate(-4.021 0)",
    fill: "#773e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1164",
    "data-name": "Trac\\xE9 1164",
    d: "M21.427,52.826l-1.2,4.146.608,4.821h1.778l1.969-2,2.16.381,1.4,2.795-1.652,4.383-2.741,1.249-3.087-3.574-3.548,2.738L12.3,69.348l-3.575-.5L1.68,69.06,1.143,67.8,0,62.4.38,57.447l.412-2.6,2.626-3.478L6.848,52.7l5.512-.386,5.113-1.35Z",
    transform: "translate(1.976 -40.579)",
    fill: "#ffc5c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1165",
    "data-name": "Trac\\xE9 1165",
    d: "M43.468,159.012l.622,4.761-3.52,2.29-6.406,2.171L29.68,167.21l.35-2.674,10.651-3.793,2.485-3.991Z",
    transform: "translate(-20.022 -124.816)",
    fill: "#ffc5c0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_273",
    "data-name": "Groupe 273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_272",
    "data-name": "Groupe 272",
    clipPath: "url(#computer-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1169",
    "data-name": "Trac\\xE9 1169",
    d: "M104.8,102.786a6.573,6.573,0,0,0-.638.713c-.2.247-.377.5-.553.766l-.033.049-.021.032c-.014.022-.027.045-.04.068a.648.648,0,0,0-.067.264.949.949,0,0,0,.065.371,2.03,2.03,0,0,0,.279.486,3.083,3.083,0,0,0,.733.7l.251-.228c-.138-.284-.294-.558-.423-.819a2,2,0,0,1-.146-.366.278.278,0,0,1-.013-.1.077.077,0,0,1-.01.035.056.056,0,0,1-.01.017c-.005.006.008-.013.011-.018l.033-.051c.177-.268.349-.54.5-.824a6.642,6.642,0,0,0,.418-.877Z",
    transform: "translate(-96.104 -81.844)",
    fill: "#330434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1170",
    "data-name": "Trac\\xE9 1170",
    d: "M47.1,104.125l-.2,2.646-2.4,1.495-1.947,1.391H39.847l-3.554-.278-2.252-.765-1.786.035-1.587.487-1.008.939-2.066.846-.472,1.1.382,2.016.069,2.364,1.6,1.991,2.92,1.068,2.335.391h5.452l4.172-2.234L46,115.532l1.252-.661,1.564-2.883v-3.1l.063-4.767Z",
    transform: "translate(-24.29 -82.911)",
    fill: "#d17613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1171",
    "data-name": "Trac\\xE9 1171",
    d: "M12.176,130.921l-.434.2.125.662-.333.635-.651-.286-.254-1.079.143-.635-.555,1,.254,1,.9.7.984-.539.079-1.063Z",
    transform: "translate(15.595 -103.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1172",
    "data-name": "Trac\\xE9 1172",
    d: "M78.931,93.166a1.835,1.835,0,0,0-1.865-.735c-1.3.2-1.752.989-1.413,1.95s.933,1.328,1.441,1.017.815-.4.65-1.7c.791,0,1.441.424,1.413.113a1.882,1.882,0,0,0-.226-.65",
    transform: "translate(-64.435 -73.578)",
    fill: "#330434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1173",
    "data-name": "Trac\\xE9 1173",
    d: "M121.439,94.76a1.688,1.688,0,0,0-1.716-.676c-1.2.182-1.612.91-1.3,1.794s.858,1.222,1.326.936.75-.372.6-1.56c.728,0,1.326.39,1.3.1a1.733,1.733,0,0,0-.208-.6",
    transform: "translate(-115.641 -74.895)",
    fill: "#330434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1174",
    "data-name": "Trac\\xE9 1174",
    d: "M12.919,110.108s-.953-.238-.919-1.736,1.975-2.728,2.417-2.266-1.464,1.093-1.362,1.952.851,2.289-.136,2.051",
    transform: "translate(13.187 -84.409)",
    fill: "#330434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1175",
    "data-name": "Trac\\xE9 1175",
    d: "M119.8,76.7s-2.388-.76-3.655-.334a2.8,2.8,0,0,0-1.62,1.1",
    transform: "translate(-113.023 -60.703)",
    fill: "#773e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    "data-name": "Trac\\xE9 1176",
    d: "M71.3,75.469s-2.226-1.15-3.547-.944a2.8,2.8,0,0,0-1.782.814",
    transform: "translate(-54.627 -59.322)",
    fill: "#773e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1177",
    "data-name": "Trac\\xE9 1177",
    d: "M92.554,135.86s-3.731-.112-4.629,0,.028,1.431.365,1.767a3.128,3.128,0,0,0,2.721.14c.926-.449,2.328-1.262,1.543-1.908",
    transform: "translate(-80.506 -108.14)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.4f28e9d05a78f1138d5b3a49b5e326dc.svg";
export { ForwardRef as ReactComponent };